<div class="upload-container">
    <div style="display: flex; flex-direction: column; gap: 5px">
        <span>{{ title }}</span>
        <ul *ngIf="subTitles.length > 0">
            <li *ngFor="let subTitle of subTitles">
                {{ subTitle }}
            </li>
        </ul>
        <input
            type="file"
            id="fileInput"
            style="display: none"
            multiple
            (change)="onFileSelected($event)"
            [accept]="acceptedFormats"
        />
        <div class="col-4 btn-group btn-block" style="align-items: center">
            <label for="fileInput" class="btn btn-sm btn-dark mr-2 rounded"> Choose Files </label>
            <span *ngIf="selectedFiles.length == 0">No file chosen</span>
            <span *ngIf="selectedFiles.length > 0">{{
                selectedFiles[selectedFiles.length - 1].name
            }}</span>
        </div>
    </div>

    <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 5px; margin-top: 10px">
        <div
            *ngFor="let file of selectedFiles; let i = index"
            style="
                background-color: #fde150;
                width: fit-content;
                border-radius: 10px;
                padding: 10px;
                position: relative;
            "
        >
            {{ file.name }}
            <a
                class="remove-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary"
                style="position: absolute; top: -5px; right: -5px; height: 2rem; width: 2rem"
                (click)="removeFile(i)"
            >
                <h6 class="text-white">x</h6>
            </a>
        </div>

        <ng-container *ngIf="!previewMode && !editMode">
            <div
                *ngFor="let file of previousFiles; let i = index"
                style="
                    background-color: #fde150;
                    width: fit-content;
                    border-radius: 10px;
                    padding: 10px;
                    position: relative;
                "
            >
                {{ file.title.split('_')[1] }}
                <a
                    class="remove-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary"
                    style="position: absolute; top: -5px; right: -5px; height: 2rem; width: 2rem"
                    (click)="removePreviousFile(i)"
                >
                    <h6 class="text-white">x</h6>
                </a>
            </div>
        </ng-container>
    </div>

    <div *ngIf="hasExceededMaxFileSize" class="alert alert-danger mt-2">
        <a class="close" (click)="removeAlert()">&times;</a>
        <span>
            Your files exceed the {{ maxFileSizeMb }} MB total upload limit. Remove or replace
            a file to stay within the limit.
        </span>
    </div>
</div>
